import {
  IDepot,
  IDepotAlias,
  IDepotAliasCreatePayload,
  IDepotAliasData,
  IDepotCreatePayload,
  IDepotData,
  IDepotEmailRecipient,
  IDepotEmailRecipientCreatePayload,
  IDepotEmailRecipientData,
  IDepotEmailRecipientUpdatePayload,
} from '../interfaces/Depot.interface';
import { axiosAuthInstance } from './Auth.service';

export const getDepotList = async (
  limit: number,
  offset: number,
  countryIds?: string[],
  searchQuery?: string
): Promise<IDepotData> => {
  const client = await axiosAuthInstance();
  let queryParams = '';
  
  countryIds?.forEach((filter) => {
    queryParams += `&countries[]=${filter}`;
  });

  if (searchQuery !== undefined && searchQuery.length > 0) {
    queryParams += `&search=${searchQuery}`;
  }

  const response = await client.get(`/depot/list?limit=${limit}&offset=${offset}${queryParams}`);

  return {
    ...response.data,
    nextLink: response.data.pagination?.nextLink,
  };
};

export const getDepot = async (id: string): Promise<IDepot> => {
  const client = await axiosAuthInstance();
  const response = await client.get(`/depot/${id}`);
  return response.data;
};

export const createDepot = async (payload: IDepotCreatePayload): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.post('/depot', payload);
  return response.data;
};

export const editDepot = async (id: string, payload: IDepotCreatePayload): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.put(`/depot/${id}`, payload);
  return response.data;
};

export const deleteDepot = async (id: string): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.delete(`/depot/${id}`);
  return response.data;
};

/** 
 * Depot Alias
 */

export const getDepotAliasList = async (
  id: string,
  limit: number,
  offset: number,
  searchQuery?: string
): Promise<IDepotAliasData> => {
  const client = await axiosAuthInstance();
  let queryParams = '';
  
  if (searchQuery !== undefined && searchQuery.length > 0) {
    queryParams += `&search=${searchQuery}`;
  }

  const response = await client.get(`/depot-alias/depot/${id}?limit=${limit}&offset=${offset}${queryParams}`);

  return {
    ...response.data,
    nextLink: response.data.pagination?.nextLink,
  };
};

export const getDepotAlias = async (id: string): Promise<IDepotAlias> => {
  const client = await axiosAuthInstance();
  const response = await client.get(`/depot-alias/${id}`);
  return response.data;
};

export const createDepotAlias = async (payload: IDepotAliasCreatePayload): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.post('/depot-alias', payload);
  return response.data;
};

export const editDepotAlias = async (id: string, payload: IDepotAliasCreatePayload): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.put(`/depot-alias/${id}`, payload);
  return response.data;
};

export const deleteDepotAlias = async (id: string): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.delete(`/depot-alias/${id}`);
  return response.data;
};

/**
 * Depot Email Recipient
 */

export const getDepotEmailRecipientList = async (
  id: string,
  limit: number,
  offset: number,
): Promise<IDepotEmailRecipientData> => {
  const client = await axiosAuthInstance();
  const response = await client.get(
    `/depot-email-recipient/depot/${id}?limit=${limit}&offset=${offset}`,
  );

  return {
    ...response.data,
    nextLink: response.data.pagination?.nextLink,
  };
};

export const createDepotEmailRecipient = async (
  payload: IDepotEmailRecipientCreatePayload,
): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.post('/depot-email-recipient', payload);
  return response.data;
};

export const editDepotEmailRecipient = async (
  id: string,
  payload: IDepotEmailRecipientUpdatePayload,
): Promise<IDepotEmailRecipient> => {
  const client = await axiosAuthInstance();
  const response = await client.put(`/depot-email-recipient/${id}`, payload);
  return response.data;
};

export const deleteDepotEmailRecipient = async (id: string): Promise<void> => {
  const client = await axiosAuthInstance();
  const response = await client.delete(`/depot-email-recipient/${id}`);
  return response.data;
};
